import { makeAutoObservable } from 'mobx';
import { CarrierUiPresenter, ProductLineCardStatus } from './pageStore';

interface ContextualProps {
  carrierData: CarrierUiPresenter;
  updateProductLineStatus: () => void;
}

export default class CarrierDelegate {
  private _carrierPresenter;
  private _updateProductLineStatus: () => void;

  public get carrier(): CarrierUiPresenter {
    return this._carrierPresenter;
  }

  public get allRecipients(): string[] {
    const defaultRecipientEmail = this._carrierPresenter.defaultRecipientEmail;
    const ccRecipients = this._carrierPresenter.ccRecipients;
    return defaultRecipientEmail ? [defaultRecipientEmail, ...ccRecipients] : ccRecipients;
  }

  public changeCarrierCheckboxStatus(): void {
    this._carrierPresenter.checked = !this._carrierPresenter.checked;
    this.updatePLStatusForCarrier();
  }

  private updatePLStatusForCarrier(): void {
    const isChecked = this._carrierPresenter.checked === true;
    let status: ProductLineCardStatus = ProductLineCardStatus.NO_CARRIERS_REQUESTED;

    if (isChecked) {
      if (this.allRecipients.length === 0) {
        status = ProductLineCardStatus.MISSING_RECIPIENTS;
      } else {
        status = ProductLineCardStatus.INCLUDED_IN_REQUEST;
      }
    } else {
      status = ProductLineCardStatus.NO_CARRIERS_REQUESTED;
    }

    this._carrierPresenter.status = status;
    this._updateProductLineStatus();
  }

  public updateRecipients(carrier: CarrierUiPresenter): void {
    this._carrierPresenter = carrier;
    this.updatePLStatusForCarrier();
  }

  constructor({ carrierData, updateProductLineStatus }: ContextualProps) {
    this._carrierPresenter = carrierData;
    this._updateProductLineStatus = updateProductLineStatus;

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
